import { useMemo } from 'react';
import compact from 'lodash/compact';
import { useRouter } from 'next/router';

import { useZigzag } from '@common/device-manager';

/**
 * PDP 웹뷰는 무조건 /app/ 경로가 포함됨
 * PDP -> PDP 이동은 /app/ 플래그가 없기 때문에 ua 검사
 * ex) app/catalog/products/{id}
 * Server/Client 모두 안정적으로 확인하기 위해 route/ua 같이 체크한다.
 */
export const useIsApp = () => {
  const router = useRouter();
  const is_app_ua = useZigzag(true);
  const is_app_route = useMemo(() => {
    try {
      const [flag] = compact((router.asPath ?? '').split('/'));

      return flag === 'app';
    } catch (err) {
      return false;
    }
  }, [router]);

  return {
    is_app: is_app_route || is_app_ua,
  };
};
